import { blurOnSearchActions } from '../../services';

export const blurOnSearchReducer = ( state = {show:false}, action ) => {
  switch ( action.type ) {
    case blurOnSearchActions.SHOW:
      return {...state, ["show"]:true};
    case blurOnSearchActions.HIDE:
      return {...state, ["show"]:false};
    default:
      return state;
  }
};